import React from 'react'

import { Button } from '@octane/spark'
import { useFeatureFlagContext } from 'contexts/FeatureFlagContextProvider'
import { DashboardItem } from 'state/dashboard/types'
import getNewApplicationPath from 'utils/getNewApplicationPath'
import navigate from 'utils/navigate'

import useUser from '../../hooks/useUser'
import { DashboardContainer, DashboardBody } from './Dashboard.styled'
import {
    LegendDashboardCSSVariables,
    QuickActions,
} from './LegendDashboard.styled'
import LegendHeader from './LegendHeader'
import { DashboardProps } from './types'

const quickActionEvent = {
    category: 'Loyalty Dashboard',
    action: 'Quick Action',
}

export default function LegendDashboard({
    data,
    components,
    dealershipName,
}: Readonly<DashboardProps>) {
    const { user } = useUser()
    const featureFlags = useFeatureFlagContext()

    return (
        <LegendDashboardCSSVariables>
            <LegendHeader generatedDate={data.dashboard.lastUpdated} />

            <DashboardContainer>
                <QuickActions>
                    <h3>Quick Actions</h3>
                    <Button
                        onClick={() => {
                            const newApplicationPath = getNewApplicationPath(
                                featureFlags,
                                user?.dealership?.primaryAssetType,
                            )

                            navigate(newApplicationPath, quickActionEvent)
                        }}
                    >
                        + New Deal
                    </Button>
                    <Button
                        onClick={() =>
                            navigate('#/saved-applications', quickActionEvent)
                        }
                    >
                        View Active Deals
                    </Button>
                    <Button
                        onClick={() =>
                            navigate(
                                'https://roadrunnerfinancial2ndorg.my.site.com/roadrunner/s/rate-sheets',
                                quickActionEvent,
                            )
                        }
                    >
                        Current Rate Sheets
                    </Button>
                    <Button
                        onClick={() =>
                            navigate(
                                'https://roadrunnerfinancial2ndorg.my.site.com/roadrunner/s/',
                                quickActionEvent,
                            )
                        }
                    >
                        Closing Documents
                    </Button>
                </QuickActions>

                <DashboardBody>
                    {data.dashboard.items.map(
                        (item: DashboardItem, index: number) => {
                            const ComponentType = components.get(item.component)
                            const componentKey = `${item.component}_${index}`

                            if (ComponentType) {
                                return (
                                    <ComponentType
                                        key={componentKey}
                                        componentStyle={item.componentStyle}
                                        data={item.data}
                                        dealershipName={dealershipName}
                                    />
                                )
                            }

                            return <div key={componentKey} />
                        },
                    )}
                </DashboardBody>
            </DashboardContainer>
        </LegendDashboardCSSVariables>
    )
}
